import {
  ListItemText,
  Typography,
  Chip,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { ReportType } from './types';
import { getCachedData } from "api/Cache";
import { ReactComponent as ReportIcon } from "assets/images/report.svg";
import { Public, Folder } from "@mui/icons-material";
import { icons } from "constants/viewer";
import * as Utils from "services/UtilsService";
import { tss } from "tss-react";

const useStyles = tss.create(() => ({
  icon: {
    width: 27,
    height: 27,
    marginRight: 10,
    color: 'rgb(0,0,0,0.53)',
  },
  layerIcon: {
    display: "inline-flex",
    alignItems: "center",
  },
}));

const getIcon = (entity: ReportType, classes: any) => {
  if (!entity.hasSubFolders) {
      return <ReportIcon className={classes.icon} />;
  }
  const Icon = entity.type === 'PROJECT' ? Public : Folder;
  return (
      <div className={classes.layerIcon}>
          <Icon className={classes.icon} />
      </div>
  );
}

const ReportItem = ({ item }: {item:ReportType}) => {
  const { classes } = useStyles();
  return (
    <ListItemButton
      component={'li'}
      sx={{
        p: '8px 24px',
        transition: 'all 0.2s',
        pointerEvents: 'none'
      }}
    >
      {getIcon(item, classes)}
      <ListItemText
        primary={
          <Typography variant={'h5'} mb={0.5} className='listItemTitle'>
            {item.name}
          </Typography>
        }
        secondary={
          <Typography variant={'h6'} mb={0.5} color={'text.secondary'} style={{fontSize: '12px'}}>
            {item.projectName}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

export { ReportItem };
